/**
 * navigationHelper.js
 * Navigation utility for handling returnUrl flow in builders
 * Created: 2025-12-28
 */

/**
 * Encode current URL as return parameter
 * @param {string} currentPath - Current path including pathname and search
 * @returns {string} - Encoded URL
 */
export const createReturnUrl = (currentPath) => {
  return encodeURIComponent(currentPath);
};

/**
 * Navigate to builder with return URL parameter
 * @param {function} navigate - React Router navigate function
 * @param {string} targetPath - Path to navigate to
 * @param {string} currentPath - Current path to return to
 */
export const navigateWithReturn = (navigate, targetPath, currentPath) => {
  const returnUrl = createReturnUrl(currentPath);
  const separator = targetPath.includes('?') ? '&' : '?';
  navigate(`${targetPath}${separator}returnUrl=${returnUrl}`);
};

/**
 * Handle return navigation after save
 * @param {function} navigate - React Router navigate function
 * @param {URLSearchParams} searchParams - URL search parameters
 * @param {string} fallbackPath - Fallback path if no returnUrl
 */
export const handleReturn = (navigate, searchParams, fallbackPath) => {
  const returnUrl = searchParams.get('returnUrl');
  if (returnUrl) {
    try {
      navigate(decodeURIComponent(returnUrl));
    } catch (error) {
      console.error('Error decoding returnUrl:', error);
      navigate(fallbackPath);
    }
  } else {
    navigate(fallbackPath);
  }
};

/**
 * Get return URL from search params
 * @param {URLSearchParams} searchParams - URL search parameters
 * @returns {string|null} - Decoded return URL or null
 */
export const getReturnUrl = (searchParams) => {
  const returnUrl = searchParams.get('returnUrl');
  if (returnUrl) {
    try {
      return decodeURIComponent(returnUrl);
    } catch (error) {
      console.error('Error decoding returnUrl:', error);
      return null;
    }
  }
  return null;
};

/**
 * Check if current page has a return URL
 * @param {URLSearchParams} searchParams - URL search parameters
 * @returns {boolean} - True if returnUrl exists
 */
export const hasReturnUrl = (searchParams) => {
  return searchParams.has('returnUrl');
};



